<template>
    <div>
    <p>This is an executable installer with bundled Java Runtime. You don't need to download anything else.</p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for Windows</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/win`">Download [{{ size }}]</a>
    </div>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered through our Update Channel. Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time. When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    <h3>Possible reports from anti-virus software</h3>

    <p>Some anti-virus programs may report viruses in the installer. This is a known issue which happens
        to installers very often. It doesn't mean that the file is infected, it rather means that
      an antivirus engine have seen malware which was packed using a similar installer.</p>

    <p>The installer was <a :href="`https://www.virustotal.com/gui/file/${virustotalHash}/detection`">checked by VirusTotal</a>
        and at the moment of writing this no engines reported positive results (which is good).</p>

    <p>If your anti-virus software reports positive result, this is most likely a false positive,
        provided that the file which you downloaded is the original one. You can check if you downloaded
        the original file by <a href="http://onlinemd5.com/">checking its MD5 checksum</a>.
      The MD5 sum of the original installer is <code>{{ md5sum }}</code></p>

    <p>If you can't or don't want to run program which your antivirus engine considers as infected,
        try using <a :href="`/dl/${version}/any`">platform-independent ZIP archive</a>.
        This distribution includes no native code and doesn't require
        Administrator privileges. It requires Java Runtime to be installed.</p>
    </div>
</template>

<script>
    export default {
        name: "DownloadWin30",
        props: {
            md5sum: String,
            releaseDate: String,
            size: String,
            version: String,
            virustotalHash: String
        }
    }
</script>

<style scoped>

</style>
